/* eslint no-underscore-dangle: 0 */
import { extendTheme, StyleFunctionProps, theme } from '@chakra-ui/react';

const customTheme = extendTheme({
    fonts: {
        heading: "'IBM Plex Sans', sans-serif",
        body: "'IBM Plex Sans', sans-serif",
        mono: 'SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace',
        numerical: '"IBM Plex Sans Condensed", sans-serif',
    },
    components: {
        Table: {
            variants: {
                DITable: (props: any) => {
                    return {
                        table: {
                            mb: 16,
                            backgroundColor: 'red',
                        },
                        th: {
                            color: '#0267EB',
                        },
                        thead: {
                            bg: 'red',
                            th: {
                                p: 2,
                                borderBottom: 'solid #ADA8A8 1px',
                            },
                        },
                        tbody: {
                            'tr:not(:last-child)': {
                                p: 2,
                                borderBottom: 'solid #E5E0DF 1px',
                            },
                        },
                    };
                },
            },
        },
        Tabs: {
            ...theme.components.Tabs,
            variants: {
                ...theme.components.Tabs.variants,
                DITabs: (props: StyleFunctionProps) => ({
                    ...theme.components.Tabs.variants?.line(props),
                    tab: {
                        ...theme.components.Tabs.variants?.line(props).tab,
                        color: 'gray.600',
                        fontWeight: '600',
                        fontSize: '14px',
                        _focus: { boxShadow: 'none' },
                        _selected: {
                            ...theme.components.Tabs.variants?.line(props).tab._selected,
                            color: 'gray.700',
                            fontWeight: '700',
                            borderBottom: '3px solid',
                        },
                    },
                }),
            },
        },
    },
    colors: {
        blueMain: '#0267EB',
        bgGray: '#faf6f6',
        borderGray: '#CAC5C4',
        gray: {
            // Data Impact gray values
            50: '#F7F3F2',
            100: '#E5E0DF',
            200: '#CAC5C4',
            300: '#ADA8A8',
            400: '#8F8B8B',
            500: '#726E6E',
            600: '#565151',
            700: '#3C3838',
            800: '#272525',
            900: '#171414',
        },
        blue: {
            // Data Impact blue values
            50: '#EBF4FF',
            100: '#C3DFFE',
            200: '#9BCAFD',
            300: '#5FABFC',
            400: '#0F81FA',
            500: '#0463C8',
            600: '#03468E',
            700: '#042B8C',
            800: '#1C4588',
            900: '#011E3C',
        },
        yellow: {
            400: '#F6BF00',
        },
    },
});

export default customTheme;
